// extracted by mini-css-extract-plugin
export default {"dataGrid":"styles-module__dataGrid__src-labstep-web-grid-SearchModal-_zIOiz"};